module.exports = __webpack_public_path__ + "static/media/expression.98e41811.png";